import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useEffect, useState } from "react";
import { Alert, Autocomplete, Divider, Grid, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { Loading } from "@/components/common/Loading";
import { CountryService } from "@/service/services/Country.service";
import { Props } from "./ModalCountryDepartament.type";
import ___PHRASE from "@/service/translate/translateService";

export const ModalCountryDepartament: React.FC<Props> = (props:any): JSX.Element => {

    const { open, closeModal, actionSelected, departament, onListDepartament, clearState, countrySelected } = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [timeZone, setTimeZone] = useState<any>([]);

    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });

    useEffect(() => {
        getTimeZone();
    }, []);

    const getTimeZone = async () => {
        setLoading(true);
        await CountryService.getTimeZone().then((data) => {
            setTimeZone(data.data || []);
           setLoading(false);
        });
    }

    const [data, setData] = useState({
        id: departament ? departament.id : '',
        code: departament ? departament.code : '',
        name: departament ? departament.name : '',
        idcountry: departament ? departament.idcountry : '',
        idtimezone: departament ? departament.idtimezone : '',
    });

    const validateForm = (values) => {
        let errors: any = {};
        if(!values.code) errors.code = "codigo requerido";
        if(!values.name) errors.name = "nombre requerido";
        // if(!values.idtimezone) errors.idtimezone = "zona horaria requerido";
        return errors;
    }

    const onSubmit = async(values, {resetForm})  => {

        const formData = {
            id: values.id,
            code: values.code,
            name: values.name,
            idcountry : countrySelected.id,
            idtimezone : values.idtimezone,
        }
        setLoading(true);
        if(departament && actionSelected=='edit'){
            await CountryService.editDepartament(formData, departament.id).then((data) => {
                onListDepartament && onListDepartament(countrySelected.id);
                closeModal && closeModal();
            })
        }else{
            await CountryService.createDepartament(formData).then((data) => {
                if(data.data.status == false){
                    setLoading(false);
                    return (
                        setSnackBarConfig(prev => ({
                            ...prev, open: true,
                            severity: 'warning',
                            message: `${data.data.message || ___PHRASE("ocurrioAlgunErrorIntentaloMasTarde")}`
                        }))
                    );
                }
                onListDepartament && onListDepartament(countrySelected.id);
                closeModal && closeModal();
            })
        }
        setLoading(false);
    }

    return(
        <>
        {loading && <Loading/>}

        <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>

        <Modal open={open} handleClose={closeModal} handle size="sm">
            <ModalHeader
                text={((departament && actionSelected=='edit') ? ___PHRASE("editar") : ___PHRASE("agregar"))+' '+___PHRASE("region")}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) =>{
                        return(
                            <form onSubmit={handleSubmit}>
                                <Grid container >

                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>{___PHRASE("codigo")}:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="code"
                                            variant="standard"
                                            type="text" 
                                            name="code"
                                            fullWidth
                                            value={values.code}
                                            onChange={handleChange}
                                            placeholder={___PHRASE("codigo")}
                                            error={errors.code && touched.code ? true : false}
                                        />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>{___PHRASE("nombre")}:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="name"
                                            variant="standard"
                                            type="text" 
                                            name="name"
                                            fullWidth
                                            value={values.name}
                                            onChange={handleChange}
                                            placeholder={___PHRASE("nombre")}
                                            error={errors.name && touched.name ? true : false}
                                        />
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>{___PHRASE("zonaHoraria")}:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Select
                                                id="idtimezone"
                                                variant="standard"
                                                value={values.idtimezone}
                                                onChange={(event) => { 
                                                setFieldValue("idtimezone", event.target.value);
                                                }}
                                                error={ errors.idtimezone && touched.idtimezone ? true : false }
                                                fullWidth
                                            >
                                                {
                                                    timeZone && timeZone.map((item, i) => {
                                                        return <MenuItem key={i} value={item.id}>{item.time_zone}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={(departament && actionSelected=='edit') ? ___PHRASE("actualizar") : ___PHRASE("registrar")}
                                    cancelText={___PHRASE("cancelar")} 
                                    onCancel={closeModal}
                                    clearState={clearState}
                                    onConfirm={handleSubmit}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
        </>
    );
}